module.exports = __webpack_public_path__ + "static/media/home_img.801341d3.png";